export default "__VITE_ASSET__BsVn7z_U__"